module.exports = __webpack_public_path__ + "media/fire.25677635.mp4";